export class Constants {
	//public static apiServer = 'http://localhost:8080';
 	//public static apiServer = 'http://www.lamagottalent.com/wack';
	// public static apiServer = 'http://www.bidamaservices.com/bsc';
	public static apiServer = 'https://epicares.org:8443';
	public static SUCCESS = 'success';
	public static INFO = 'info';
	public static WARN = 'warn';
	public static ERROR = 'error';
}